import { motion } from "framer-motion";

// Masked line reveal — split text into words wrapped in mask
export function RevealText({ text, className = "", delay = 0, as: Tag = "span" }) {
  const words = text.split(" ");
  return (
    <Tag className={className}>
      {words.map((w, i) => (
        <span key={i} className="reveal-mask inline-block mr-[0.25em] align-bottom">
          <motion.span
            className="reveal-line inline-block"
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{
              duration: 0.9,
              ease: [0.77, 0, 0.175, 1],
              delay: delay + i * 0.06,
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ClipImage({ src, alt, className = "", delay = 0 }) {
  return (
    <div className={"overflow-hidden " + className}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        initial={{ scale: 1.25, clipPath: "inset(100% 0 0 0)" }}
        whileInView={{ scale: 1, clipPath: "inset(0% 0 0 0)" }}
        viewport={{ once: true, margin: "-5% 0px" }}
        transition={{ duration: 1.4, ease: [0.77, 0, 0.175, 1], delay }}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
